import { makeObservable, observable, action } from "mobx";

import { RootStore } from ".";
import { DEFAULT_RESPONSE_LIST } from "../constants";
import { HttpResponse, HttpResponseStatus } from "../api";
import {
  Jackpot,
  JackpotRequest,
  JackpotResponse,
  JackpotTicket,
} from "../models/jackpot";
import { jackpotController } from "../api/controllers/jackpots";
import { PrintTypes } from "../enums";
import { PrintTypeModel, Ticket } from "../models";
import { JackpotDetails, JackpotModal } from "../models/modal";

export class JackpotStore {
  private rootStore?: RootStore;

  public jackpotList = new HttpResponse<JackpotResponse>(DEFAULT_RESPONSE_LIST);

  public payTicketResponse = new HttpResponse<Ticket | null>(
    null,
    HttpResponseStatus.Default,
  );

  public jackpotTicket: JackpotTicket | null = null;
  public jackpotDetails = new HttpResponse<JackpotDetails>(
    {} as JackpotDetails,
  );

  public ticketPrintData: PrintTypeModel = {
    type: PrintTypes.None,
    data: null,
  };

  constructor(rootStore?: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      jackpotList: observable,
      jackpotTicket: observable,
      jackpotDetails: observable,
      ticketPrintData: observable,
      payTicketResponse: observable,
      setJackpotList: action.bound,
      setJackpotTicket: action.bound,
      setTicketPrintData: action.bound,
      setPayTicketResponse: action.bound,
    });
  }

  public setJackpotList(data: HttpResponse<JackpotResponse>): void {
    this.jackpotList = data;
  }

  public setJackpotDetails(data: HttpResponse<JackpotDetails>): void {
    this.jackpotDetails = data;
  }

  public setJackpotTicket(data: JackpotTicket | null): void {
    this.jackpotTicket = data;
  }

  public setPayTicketResponse(value: HttpResponse<Ticket | null>): void {
    this.payTicketResponse = value;
  }

  public setTicketPrintData(value: PrintTypeModel): void {
    this.ticketPrintData = value;
  }

  public async getJackpotList(params: JackpotRequest): Promise<void> {
    this.setJackpotList(this.jackpotList.fetching());
    const result = await jackpotController.getJackpot(params);
    this.setJackpotList(this.jackpotList.fetched(result));
  }

  public async getJackpotDetails(id: number, level: number): Promise<void> {
    this.setJackpotDetails(this.jackpotDetails.fetching());
    const result = await jackpotController.getJackpotDetails(id, level);
    this.setJackpotDetails(this.jackpotDetails.fetched(result));
  }

  public resetJackpotDetails(): void {
    this.setJackpotDetails(new HttpResponse({} as JackpotDetails, HttpResponseStatus.Default));
  }

  public resetJackpotTicket(): void {
    this.setJackpotTicket(null);
  }
}
